<template>    
<div id="PessoaEquipamento" class="container">
  <div id="modal-atribuicao" v-if="showModalAtribuicao" @close="showModalAtribuicao = false" >
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
                <slot name="header">
                  Atribuição de Equipamento
                </slot>
              </div>
              <div class="modal-body">
                <slot name="body">
                  <Atribuicao :equipamentoId="linhaSelE.id" :acao="acao" @atribuicao-cancel="closeModalAtribuicao()" @atribuicao-ok="onAdd"  ></Atribuicao>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  <div class="title">
    <h5>
      <router-link class="btn btn-default" :to="{ name: 'ListPessoas' }" >
        <i class="fa fa-angle-left"></i> Voltar à Lista
      </router-link>&nbsp;
      Atribuição de Equipamentos
    </h5>
  </div>
  <div class="container title-pessoa">
    <span class="alert alert-primary">
      {{ePessoa.nome_razao}} ({{ePessoa.unid_neg.descricao}})
    </span>
  </div>
  <p class="alert alert-danger" v-if="errors.length">
    <span v-for="error in errors" v-bind:key="error">{{ error }}</span>
  </p>
  <div class="row centered small">
    <div class="form-group col-md-5 table-origem">
    <div class="card text-centered">
      <div class="form-group card-header">
        <form class="form-inline" v-on:submit.prevent>
          <i class="fas fa-search" aria-hidden="true"></i>
          <input class="form-control form-control-sm ml-3 w-75" type="text" aria-label="Pesquisar" v-model="tBusca" v-on:keydown="eBusca">
        </form>
        <div class="accordion" id="accordionExample">
          <div class="card">
            <div class="card-header ch-filtros" id="headingOne">
              <h5 class="mb-0">
                <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseFiltro" aria-expanded="true" aria-controls="collapseFiltro">
                  Filtros
                </button>
              </h5>
            </div>
            <div class="row collapse" id="collapseFiltro">
              <div class="form-group">
                <label v-for="t in tipos" v-bind:key="t.id"  class="container checkbox-inline">
                  <input v-on:change="selecionaTipo(t.id)"  type="checkbox"> {{t.descricao}}
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="table-responsive ">
          <table class="table  table-bordered table-sm">
            <tbody>
              <tr v-for="obj in equipamentos" v-bind:key="obj.id" @click="setLinhaSelection(obj)" v-bind:class="{ 'linhaSel': linhaSel.id == obj.id }">
                <td>
                  <div>
                    <span class="badge badge-secondary badge-pill ">
                      {{obj.tipo_equipamento.descricao}} 
                    </span>
                    {{obj.marca_modelo}}
                  </div>
                  <span class="text-muted" v-if="obj.imei1">
                  IMEI: {{obj.imei1}}<span v-if ="obj.imei2">/{{obj.imei2}}</span>
                  </span>
                  <span class="text-muted" v-if="obj.num_serie">
                  NS: {{obj.num_serie}}
                  </span>
                </td>            
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="form-group col-md-2 align-self-center">
      <button class="btn btn-default container align-self-center d-flex justify-content-center" v-on:click="setShowModalAtribuicao('Atribuir Equipamento', 'add')"  >
        <i class="fa fa-angle-right"></i>
      </button>
      <button class="btn btn-default container align-self-center d-flex justify-content-center" v-on:click="setShowModalAtribuicao('Recolher Equipamento', 'rem')"  >      
        <i class="fa fa-angle-left"></i>
      </button>
    </div>
    <div class="col-md-5">
      <div class="card">
        <div class="card-header text-center">
          Equipamentos Atribuídos
        </div>
        <div class="table-responsive ">
          <table class="table  table-bordered table-sm">
            <tbody>
              <tr v-for="obj in equipamentosA" v-bind:key="obj.id" @click="setLinhaSelectionA(obj)" v-bind:class="{ 'linhaSel': linhaSelA.id == obj.id }">
                <td>
                  <div>
                    <span class="badge badge-secondary badge-pill">
                      {{obj.tipo_equipamento.descricao}} 
                    </span>
                    {{obj.marca_modelo}}
                  </div>
                  <span class="text-muted" v-if="obj.imei1">
                  IMEI: {{obj.imei1}}<span v-if ="obj.imei2">/{{obj.imei2}}</span>
                  </span>
                  <span class="text-muted" v-if="obj.num_serie">
                  NS: {{obj.num_serie}}
                  </span>
                </td>            
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="container small">
    <div class="card">
      <div class="card-header text-center">
        Histórico
      </div>
      <div class="table-responsive ">
        <table class="table  table-bordered table-sm">
          <tbody>
            <tr v-for="obj in pessoaEquipamentos" v-bind:key="obj.id">
              <td>
                <div>
                  <span class="badge badge-pill" v-bind:class="{ 'badge-primary': obj.acao == 'add', 'badge-danger': obj.acao == 'rem' }" >
                    {{obj.data | formatDateTime}} 
                  </span>
                  {{obj.observacao}} - {{obj.pessoa_nome}}
                </div>
              </td>            
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>
</template>
<script>

import vSelect from 'vue-select'
import Atribuicao from './Atribuicao'

const fb = require('../../config/db.js')

export default {
  name: 'PessoaEquipamento',
  components: {
    vSelect,
    Atribuicao
  },
  data(){
    return {
      acao: '',
      unid_neg: [],
      equipamentos: [],
      equipamentosA: [],
      pessoaEquipamentos: [],
      pessoaEquipamento: {},
      errors: [],
      showModalAtribuicao: false,
      linhaSel: {},
      linhaSelA: {},
      parametro: null,
      tiposSelecionados: [],
      tipos: [],
      ePessoa: {'nome_razao': '', 'unid_neg': { 'descricao' : '' }},
      tBusca: '',
      linhaSelE: {},
      atribuicao: {
        'nome_razao': '',
        'fantasia': '',
        'cnpj_cpf': '',
        'telefone': '',
      },
    }
  },

  created() {
    this.atualizaTabela();
  },
  methods: {
    atualizaTabela(){
      this.linhaSel = {};
      this.linhaSelA = {};
      this.getPessoa();
      this.getEquipamentos();
      this.getEquipamentosA();
      this.getTipoEquipamentos();
    },
    eBusca: function(){
      if (this.tBusca.length >= 3)
        this.getEquipamentos(this.tBusca)
      else
        this.getEquipamentos('');
    },
    getTipoEquipamentos(){
      fb.TipoEquipamento.get().then(querySnapshot =>{
        const objects = []
        let tp = []
        querySnapshot.forEach((doc)=>{
          tp =  doc.data();
          tp.id = doc.id;
          objects.push(tp);
        });
        this.tipos = objects;
      });
    },
    selecionaTipo(id){
      const i = this.tiposSelecionados.indexOf(id);
      if (i >= 0)
        this.tiposSelecionados.splice(i, 1);
      else
        this.tiposSelecionados.push(id);

      if (this.tBusca.length >= 3)
        this.getEquipamentos(this.tBusca)
      else
        this.getEquipamentos('');
    },
    setShowModalAtribuicao(texto, acao){
      if (acao == 'add'){
        this.errors = [];
        if (!Object.keys(this.linhaSel).length)
          this.errors.push('Selecione um equipamento');
        
        if (this.errors.length)
          return;
        
        this.linhaSelE = this.linhaSel;

      } else {
        this.errors = [];
        if (!Object.keys(this.linhaSelA).length)
          this.errors.push('Selecione um equipamento');
        
        if (this.errors.length)
          return;
        
        this.linhaSelE = this.linhaSelA;
        
      } 
      this.texto = texto;
      this.acao = acao;
      this.showModalAtribuicao = true;
    },
    closeModalAtribuicao(){
      this.showModalAtribuicao = false;
    },
    setLinhaSelection(objLinha){
      this.linhaSelA = {};
      this.linhaSel = objLinha;
      this.getHistorico(this.linhaSel.id);
    },
    setLinhaSelectionA(objLinha){
      this.linhaSelA = objLinha;
      this.linhaSel = {};
      this.getHistorico(this.linhaSelA.id);
    },
    getNomePessoa(pessoa_id){
      var pessoa = {};
      fb.Pessoas.doc(pessoa_id).onSnapshot(p => {
        pessoa = p.data();
        pessoa.id = p.id;
        return pessoa.nome_razao;
      });
    },
    getHistorico(equipamento_id){
      fb.PessoaEquipamento.where('equipamento_id', '==', equipamento_id).orderBy('data_system', 'desc').orderBy('acao', 'desc').get().then(querySnapshot =>{
        const objects = []
        querySnapshot.forEach((doc)=>{
          this.pessoaEquipamento =  doc.data();
          this.pessoaEquipamento.id = doc.id;
          objects.push(this.pessoaEquipamento);
        });
        this.pessoaEquipamentos = objects;
      });
    },
    parseData(dt){
      var _dt = dt.split('-');
      return _dt[2]+'/'+_dt[1]+'/'+_dt[0];
    },
    getPessoa(){
      var pessoa = [];
      fb.Pessoas.doc(this.$route.params.idpessoa).onSnapshot(p => {
        pessoa = p.data();
        pessoa.id = p.id;
        this.ePessoa = pessoa;
      });
    },
    getEquipamentosA(){
      this.linhaSelA = {};
      fb.Equipamento.where("pessoa_id", "==", this.$route.params.idpessoa).get().then(querySnapshot =>{
        const objects = []
        querySnapshot.forEach((doc)=>{
          this.newEquipamento =  doc.data();
          this.newEquipamento.id = doc.id;
          objects.push(this.newEquipamento);
        });
        this.equipamentosA = objects;
      });

    },
    getEquipamentos(busca){
      this.linhaSel = {};
      if (String(busca).trim() == ''){
        fb.Equipamento.where('del', '==', 'n').where("pessoa_id", "==", null).get().then(querySnapshot =>{
          const objects = []
          querySnapshot.forEach((doc)=>{
            this.newEquipamento =  doc.data();
            this.newEquipamento.id = doc.id;
            if (this.tiposSelecionados.length <= 0) {
              objects.push(this.newEquipamento);
            } else { 
              if(this.tiposSelecionados.indexOf(this.newEquipamento.tipo_equipamento.idtipo_equipamento) >= 0) { 
                objects.push(this.newEquipamento);
              }
            }          
          });
          this.equipamentos = objects;
        });
      }else{
        this.equipamentos = []
        fb.Equipamento.where('del', '==', 'n').where("pessoa_id", "==", null).get().then(querySnapshot =>{
          const objects = []
          querySnapshot.forEach((doc)=>{
            this.newEquipamento =  doc.data();
            this.newEquipamento.id = doc.id;
            if ((String(this.newEquipamento.tipo_equipamento.descricao).toUpperCase().search(this.tBusca.toUpperCase()) >= 0) || 
            (String(this.newEquipamento.equipamento).toUpperCase().search(this.tBusca.toUpperCase()) >= 0) || 
            (String(this.newEquipamento.imei1).toUpperCase().search(this.tBusca.toUpperCase()) >= 0) ||
            (String(this.newEquipamento.imei2).toUpperCase().search(this.tBusca.toUpperCase()) >= 0) ||
            (String(this.newEquipamento.num_serie).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)) {
              if (this.tiposSelecionados.length <= 0) {
                objects.push(this.newEquipamento);
              } else { 
                if(this.tiposSelecionados.indexOf(this.newEquipamento.tipo_equipamento.idtipo_equipamento) >= 0) { 
                  objects.push(this.newEquipamento);
                }
              }          
            }
          });
          this.equipamentos = objects;
        });
      }
    },
    onAdd(obs, acao){
      
      fb.PessoaEquipamento.add({
        'acao': acao,
        'pessoa_id': this.ePessoa.id,
        'pessoa_nome': this.ePessoa.nome_razao,
        'equipamento_id' : this.linhaSelE.id,
        'observacao': obs,
        'data': new Date(),
        'data_system': new Date(),
        'usuario_acao': fb.auth.currentUser.email
      });

      if (acao == 'add')
        fb.Equipamento.doc(this.linhaSel.id).update({
          'pessoa_id': this.ePessoa.id,
          'pessoa_nome': this.ePessoa.nome_razao
        });
      else
        fb.Equipamento.doc(this.linhaSelA.id).update({
          'pessoa_id': null,
          'pessoa_nome': ''
        });

      this.atualizaTabela();
      this.closeModalAtribuicao();
    },
    
  },
  firestore: function() {
    
  }
}
</script>
<style scoped>

  .ch-filtros{
    padding: 0px !important;
  }
  
  .mb-0 button {
    padding: 2px !important;
    margin: 0px !important;
  }

  .linhaSel{
    background-color:lightblue;
  }
  .table-responsive{
    display: block; 
    height: 250px; 
    max-height: 250px;
    min-height: 250px;
    overflow: auto;
  }

  .title, .title-pessoa{
    padding: 12px;
  }
  .card{
    margin: 10px;
  }
  .row{
    margin: 10px;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 90%;
    max-height: calc(100% - 120px);
    overflow-y: scroll;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-default-button {
    float: right;
  } 

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .btn {
    margin-bottom: 5px;
  }

</style>




